import styled from 'styled-components'
import {useState} from 'react'
import {useParams} from 'react-router-dom'
import RouteContainer from '../../../common/styles/RouteContainer'
import NoContentForFullScreen from '../../../common/NoContentForFullScreen'
import RowSpacer from '../../../common/styles/RowSpacer'
import LibraryMembershipCardLoading from './LibraryMembershipCardLoading'
import LibraryMembershipCard from './LibraryMembershipCard'
import useLibraryMembership from '../useLibraryMembership'
import LibraryMembershipDetailLibraryCard from './LibraryMembershipDetailLibraryCard'
import {Button} from 'react-bootstrap'
import ColorConfig from '../../../config/ColorConfig'
import BooksitoutImages from '../../../images/BooksitoutImages'
import useDetectOS from '../useDetectOS'
import useLoginStore from "../../login/useLoginStore";
import LibraryMembershipDetailPasswordCard from "./LibraryMembershipDetailPasswordCard";
import LibraryMembershipDetailOwnerNameCard from "./LibraryMembershipDetailOwnerNameCard";
import LibraryMembershipDetailStatusCard, { LibraryMembershipDetailStatusCardLoading } from "./LibraryMembershipDetailStatusCard";

const LibraryMembershipDetailRoute = () => {
    const {membershipId} = useParams()
    const [membership, isLoading, isNotFound, deleteMembership] = useLibraryMembership(Number(membershipId) ?? 0)
    const accessToken = useLoginStore.getState().accessToken

    const {isIOS} = useDetectOS()

    // Edited in the 소유자 card; undefined = not edited on this page yet
    const [editedOwnerName, setEditedOwnerName] = useState<string | null | undefined>(undefined)

    if (isNotFound) return <NoContentForFullScreen message="도서관 회원증이 없어요"/>

    return (
        <RouteContainer>
            <RowSpacer/>

            {isLoading ? (
                <LibraryMembershipCardLoading padding={20}/>
            ) : (
                <MembershipContainer>
					<span className="not-clickable">
						<LibraryMembershipCard
                            membership={membership && editedOwnerName !== undefined ? {...membership, ownerName: editedOwnerName} : membership}
                            width={2}
                        />
					</span>

                    <DeleteButton onClick={() => deleteMembership()}>삭제</DeleteButton>
                </MembershipContainer>
            )}
            <RowSpacer/>

            <LibraryMembershipDetailPasswordCard passwordFromServer={membership?.password ?? null}/>
            <RowSpacer/>

            <LibraryMembershipDetailOwnerNameCard
                ownerNameFromServer={membership?.ownerName ?? null}
                onChange={setEditedOwnerName}
            />
            <RowSpacer/>

            {isLoading ? (
                <>
                    <LibraryMembershipDetailStatusCardLoading />
                    <RowSpacer/>
                </>
            ) : (
                membership &&
                <>
                    <LibraryMembershipDetailStatusCard membership={membership}/>
                    <RowSpacer/>
                </>
            )}

            <LibraryMembershipDetailLibraryCard libraryList={membership?.usableLibrary ?? []}/>
            <RowSpacer/>

            {isIOS && (
                <div className={'d-flex justify-content-end'}>
                    <a href={`${process.env.REACT_APP_API_URL}/v1/library/membership/${membershipId}/apple-wallet?accessToken=${accessToken}`}>
                        <img src={BooksitoutImages.Membership.appleWallet} alt="" className="clickable"
                             style={{width: '244px'}}/>
                    </a>
                </div>
            )}
            <RowSpacer size={40}/>
        </RouteContainer>
    )
}

const MembershipContainer = styled.div`
    position: relative;
`

const DeleteButton = styled(Button)`
    position: absolute;
    bottom: 10px;
    right: 10px;

    color: white;
    background-color: ${ColorConfig.Danger};

    border: none;

    &:hover {
        background-color: ${ColorConfig.DangerHover};
    }
`

export default LibraryMembershipDetailRoute
